
import { createIdCard, createQualification, listDataQualification, quanlificationModify, saveQualification } from '@/zsm-api-new/qualification.js'
const state = {

}

const mutations = {

}

const actions = {

  /*  // 上传资质
  createQualification({ commit }, info) {
    return new Promise((resolve, reject) => {
      createQualification(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  //修改资质信息
  quanlificationModify({ commit }, info) {
    return new Promise((resolve, reject) => {
      quanlificationModify(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 上传身份证或者营业执照等信息
  createIdCard({ commit }, info) {
    return new Promise((resolve, reject) => {
      createIdCard(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }, */

  // 查看资质列表
  listDataQualification({ commit }, info) {
    return new Promise((resolve, reject) => {
      listDataQualification(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 上传资质
  saveQualification({ commit }, info) {
    return new Promise((resolve, reject) => {
      saveQualification(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
